<template>
  <div class="orderManagement-container">
    <v-header title="订单管理"></v-header>
    <el-container class="container">
      <el-header>
        <el-row :gutter="20">
          <el-col :span="6">
            <div>
              <label class="title">业务来源：</label>
              <el-select size="small" v-model="queryParams.partner" clearable placeholder="请选择业务来源">
                <el-option v-for="item in partnerOptions" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <label class="title">分公司：</label>
              <el-select size="small" v-model="queryParams.ecobranchId" :clearable="clearable"
                         placeholder="请选择分公司">
                <el-option v-for="item in ecobranchIdOptions" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <label class="title">经代公司：</label>
              <el-input size="small" v-model="queryParams.companyCode" clearable placeholder="请输入经代公司"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div>
              <label class="title">销售人员编码：</label>
              <el-input size="small" v-model="queryParams.pcardid" clearable placeholder="请输入销售人员编码"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div>
              <label class="title">销售人员姓名：</label>
              <el-input size="small" v-model="queryParams.adPsnname" clearable placeholder="请输入销售人员姓名"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <label class="title">产品名称：</label>
              <el-input size="small" v-model="queryParams.productName" clearable placeholder="请输入产品名称"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <label class="title">投保人姓名：</label>
              <el-input size="small" v-model="queryParams.appntName" clearable placeholder="请输入投保人姓名"></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <label class="title">被保人姓名：</label>
              <el-input size="small" v-model="queryParams.insuredName" clearable placeholder="请输入被保人姓名"></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <div>
              <label class="title">保单号：</label>
              <el-input size="small" v-model="queryParams.contNo" clearable placeholder="请输入保单号"></el-input>
            </div>
          </el-col>
          <el-col :span="12">
            <div>
              <label class="title">提交日期：</label>
              <el-date-picker
                size="small"
                v-model="queryParams.value2"
                type="daterange"
                align="center"
                :editable="false"
                unlink-panels
                range-separator="至"
                start-placeholder="起始日期"
                end-placeholder="截止日期"
                value-format="yyyy-MM-dd"
                @change="changeDate">
              </el-date-picker>
              <!--              <el-date-picker size="small" v-model="queryParams.beginDate" type="date" value-format="yyyy-MM-dd"-->
              <!--                              :picker-options="pickerOptionsStart" placeholder="开始日期"></el-date-picker>-->
              <!--              <span>&nbsp;至&nbsp;</span>-->
              <!--              <el-date-picker size="small" v-model="queryParams.endDate" type="date" value-format="yyyy-MM-dd"-->
              <!--                              :picker-options="pickerOptionsEnd" placeholder="截止日期"></el-date-picker>-->
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <div>
              <el-button type="primary" size="small" @click="searchFunc">搜索</el-button>
              <el-button type="primary" size="small" @click="resetFunc">重置</el-button>
              <el-button type="primary" size="small" @click="exportFunc">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-header>

      <el-main>
        <el-table
          v-loading="loading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :data="tableData"
          border
          height="400"
          stripe="true"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="partner"
            show-overflow-tooltip="true"
            label="业务来源">
          </el-table-column>
          <el-table-column
            align="center"
            prop="ecobranchId"
            show-overflow-tooltip="true"
            label="分公司">
          </el-table-column>
          <el-table-column
            align="center"
            prop="companyCode"
            show-overflow-tooltip="true"
            label="经代公司">
          </el-table-column>
          <el-table-column
            align="center"
            prop="adPsnname"
            label="销售人员姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="contNo"
            show-overflow-tooltip="true"
            label="保单号">
          </el-table-column>
          <el-table-column
            align="center"
            prop="productName"
            show-overflow-tooltip="true"
            label="产品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="appntName"
            show-overflow-tooltip="true"
            label="投保人姓名">
          </el-table-column>
          <el-table-column
            align="center"
            prop="prem"
            show-overflow-tooltip="true"
            label="总保费">
          </el-table-column>
          <el-table-column
            align="center"
            prop="commitDate"
            show-overflow-tooltip="true"
            label="投保时间">
          </el-table-column>
          <el-table-column
            align="center"
            prop="orderStatus"
            show-overflow-tooltip="true"
            label="订单状态">
          </el-table-column>
          <el-table-column
            align="center"
            label="操作">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="success" size="mini">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>

      <el-footer>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="queryParams.page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import url from '@/modules/url'
import api from '@/modules/api'
import vHeader from '@/layout/Header1.vue'

let nowday = new Date();
let year = nowday.getFullYear();
let month = nowday.getMonth();

let beginDate = new Date(1990, month, 1);
month = month + 1;
let endDate = new Date(year + 5, month, 0);
export default {
  name: 'orderManagement',
  components: {vHeader},
  data() {
    return {
      partnerOptions: [], // 存储业务来源下拉菜单数据的集合
      ecobranchIdOptions: [], // 存储分公司下拉菜单数据的集合
      token: '', // 设置存储token的变量
      clearable: '', // 定义控制分公司下拉菜单是否可以有清空操作的变量
      ecobranchIdByToken: '', // 定义存储根据token查询出的要默认展示的分公司code
      // 定义查询条件的参数对象
      queryParams: {
        partner: 'JFE001', // 业务来源
        ecobranchId: '', // 分公司
        companyCode: '',// 经代公司
        pcardid: '', // 销售人员编码
        adPsnname: '', // 销售人员姓名
        productName: '', // 产品名称
        appntName: '', // 投保人姓名
        insuredName: '', // 被保人姓名
        contNo: '', // 保单号
        beginDate: '', // 提交起始时
        endDate: '', // 提交截止时间
        page: 1, // 页码数，初始化默认为'1'
        value2: '' // 存储提交日期变量原始数据
      },
      // minDate: '',
      // maxDate: '',
      // pickerOptions: {
      //   onPick: ({maxDate, minDate}) => {
      //     this.selectDate = minDate.getTime();
      //
      //     if (!maxDate && minDate) {
      //       let d1 = new Date(minDate)
      //       d1.setDate(d1.getDate() - 180)
      //       beginDate = new Date(d1)
      //       let d = new Date(minDate)
      //       d.setDate(d.getDate() + 180)
      //       endDate = new Date(d)
      //     }
      //     if (maxDate) {
      //       this.selectDate = '';
      //       year = minDate.getFullYear()
      //       month = minDate.getMonth() + 1
      //     }
      //   },
      //   disabledDate: time => {
      //     // var day = new Date();
      //     return (
      //       time.getTime() < beginDate.getTime() || time.getTime() > endDate.getTime()
      //     );
      //   }
      // },
      // 设置时间范围选项中，截止时间不能早于起始时间的方法
      // pickerOptionsStart: {
      //   disabledDate: time => {
      //     if (this.queryParams.endDate) {
      //       return time.getTime() > new Date(this.queryParams.endDate).getTime()
      //     }
      //   }
      // },
      // 设置时间范围选项中，起始时间不能晚于截止时间的方法
      // pickerOptionsEnd: {
      //   disabledDate: time => {
      //     return time.getTime() > Date.now() - 8.64e6;//如果不包括今天。就是return time.getTime() > Date.now() - 24*3600*1000;
      //   }
      // disabledDate: time => {
      //   if (this.queryParams.beginDate) {
      //     return time.getTime() < new Date(this.queryParams.beginDate).getTime()
      //   }
      // }
      // },
      tableData: [], // 定义存储表格数据的集合
      total: '', // 数据总条数
      loading: false // 定义是否开启表格的加载遮罩的变量
    }
  },
  mounted() {
    // 开启表格加载遮罩层
    this.loading = true
    // 调用获取coookie中得token数据的方法
    this.getCookieData()
    // 调用查询获取业务来源下拉菜单数据集合的方法
    this.getPartnerSelectDataFunc()
    // 调用查询获取分公司下拉菜单数据集合的方法
    this.getEcobranchIdSelectDataFunc()
    // 为了防止接口异步调用问题，给查询获取表格数据的方法添加一个1.5秒的等待时间
    setTimeout(() => {
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    }, 1500)

  },
  methods: {
    /**
     * @Description: 获取coookie中得token数据的方法
     * @author:zhangqi
     * @Date:2021-12-07
     */
    getCookieData() {
      // 先重置清空变量，防止数据有缓存
      this.token = ''
      let arr,
        reg = new RegExp('(^| )' + 'jtl' + '=([^;]*)(;|$)'),
        obj = document.cookie.match(reg);
      obj instanceof Array && (arr = obj);
      this.token = arr && unescape(arr[2])
    },

    /**
     * @Description: 查询获取业务来源下拉菜单数据集合的方法
     * @author:zhangqi
     * @Date:2021-11-29
     */
    getPartnerSelectDataFunc() {
      // 定义参数格式
      let param = {
        'queryType': 'partner'
      }
      // 调用查询数据的接口，获取数据
      api.post(url.getOrderEnum, param, res => {
        if (res.isSuccess) {
          // 将数据赋值给存储业务来源下拉菜单数据的集合
          this.partnerOptions = JSON.parse(res.data)
        } else {
          this.$message({
            type: 'error',
            message: res.error
          });
        }
      })
    },

    /**
     * @Description: 查询获取分公司下拉菜单数据集合的方法
     * @author:zhangqi
     * @Date:2021-11-29
     */
    getEcobranchIdSelectDataFunc() {
      // 先重置清空变量，防止数据缓存
      this.ecobranchIdByToken = ''
      // 定义参数格式
      let param = {
        'jwt': this.token,
        'queryType': 'companyCode'
      }
      // 调用查询数据的接口，获取数据
      api.post(url.getOrderEnum, param, res => {
        console.log(res, 1593574568522)
        if (res.isSuccess) {
          // 将数据赋值给存储分公司下拉菜单数据的集合
          this.ecobranchIdOptions = JSON.parse(res.data)
          // 判断是否存在'companyCode'字段
          if (!!res.companyCode) {
            // 给分公司字段赋值
            this.queryParams.ecobranchId = res.companyCode
            // 给存储根据token查询出的要默认展示的分公司code进行赋值
            this.ecobranchIdByToken = res.companyCode
            // 接口返回中存在'companyCode'数据，表示要是设置分公司下拉菜单不可有清空操作，所以给变量赋值为false
            this.clearable = false
          } else {
            // 接口返回中不存在'companyCode'数据，清空数据，不给分公司下拉菜单设置初始默认数据
            this.queryParams.ecobranchId = ''
            // 接口返回中不存在'companyCode'数据，表示要是设置分公司下拉菜单可以有清空操作，所以给变量赋值为true
            this.clearable = true
          }
        } else {
          this.$message({
            type: 'error',
            message: res.error
          });
        }
      })
    },

    /**
     * @Description: 选择时间范围时，将所选时间范围，分别赋值给起始时间与结束时间的方法
     * params: date--当前选择的时间范围数据
     * @author:zhangqi
     * @Date:2021-12-06
     */
    changeDate(date) {
      if (date != null) {
        // 将起始日期赋值给对应的变量
        this.queryParams.beginDate = date[0] + ' 00:00:00'
        // 将截止日期赋值给对应的变量
        this.queryParams.endDate = date[1] + ' 23:59:59'
      } else {
        this.queryParams.beginDate = ''
        this.queryParams.endDate = ''
      }
    },

    /**
     * @Description: 查询获取表格数据的方法
     * @author:zhangqi
     * @Date:2021-11-24
     */
    queryDataFunc() {
      // 调用查询表格数据的接口，获取数据
      api.post(url.getOrderList, this.queryParams, res => {
        if (res.isSuccess) {
          // 将数据赋值给存储表格数据的集合
          this.tableData = JSON.parse(res.data)
          // 将数据总条数赋值给对应的变量
          this.total = ~~res.count
        } else {
          this.$message({
            type: 'error',
            message: res.error
          });
        }
        // 关闭表格加载遮罩层
        this.loading = false
      })
    },

    /**
     * @Description: 点击查询按钮时，触发的方法
     * @author:zhangqi
     * @Date:2021-11-24
     */
    searchFunc() {
      // 点击搜索时，要将页码数重置为1，因为查询的是从第一页开始的数据
      this.queryParams.page = 1
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    },

    /**
     * @Description: 点击重置按钮时，触发的方法
     * @author:zhangqi
     * @Date:2021-11-24
     */
    resetFunc() {
      Object.keys(this.queryParams).forEach(item => {
        this.queryParams[item] = ''
      })
      // 给业务来源条件赋初始值
      this.queryParams.partner = 'JFE001'
      // 根据是否可以清空分公司下拉菜单的操作，判断在点击重置后是否给分公司下拉菜单数据进行赋值
      if (!this.clearable) {
        // 给分公司条件赋初始值
        this.queryParams.ecobranchId = this.ecobranchIdByToken
      }
      // 点击搜索时，要将页码数重置为1，因为查询的是从第一页开始的数据
      this.queryParams.page = 1
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    },

    /**
     * @Description: 点击导出按钮时，触发的方法
     * @author:zhangqi
     * @Date:2021-11-24
     */
    exportFunc() {
      // 开启表格加载遮罩层
      this.loading = true
      api.post(url.getExcel, this.queryParams, res => {
        // 关闭表格加载遮罩层
        this.loading = false
        if (res.isSuccess === true) {
          window.location.href = res.data
        } else {
          this.$message.error(res.error)
        }
      })
    },

    /**
     * @Description: 切换当前页码时，触发的方法
     * @author:zhangqi
     * @Date:2021-11-24
     */
    handleCurrentChange(val) {
      // 切换页码后，将当前的页码数赋值给变量
      this.queryParams.page = val
      // 调用查询获取表格数据的方法
      this.queryDataFunc()
    },

    /**
     * @Description: 点击表格中'查看详情'按钮，执行的方法
     * params: row--表格中当前行的所有数据
     * @author:zhangqi
     * @Date:2021-12-02
     */
    handleClick(row) {
      // 跳转到订单详情页面
      this.$router.push({
        name: 'orderInfo',
        query: {
          orderNo: row.orderNo
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.orderManagement-container {
  .headercom {
    position: relative;
  }

  .container {
    width: calc(100% - 30px);
    margin: 0 auto;
    margin-top: 15px;
    background: #FFFFFF;
  }

  .el-header {
    height: auto !important;

    .el-row {
      margin-top: 20px;
    }

    .el-input {
      width: 210px;
    }
  }

  .el-main {
    /deep/ thead {
      .el-table__cell {
        background: #F5F7FA;
      }
    }
  }

  .el-footer {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/performance/orderManagement.vue